import { Input, InputProps } from "antd";
import React from "react";

import "./styles.scss";

type CustomInputType = InputProps & {
  className?: string;
};

const CustomInput = ({ className, ...props }: CustomInputType) => {
  return <Input className={`CustomInput ${className}`} {...props} />;
};

export default CustomInput;
